import { lazy, Suspense, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import PublicTeachingApp from "./PublicTeachingApp";
import { isPublicTeachingPath } from "./utils/teaching-paths";
import Loader from "./components/common/Loader";

const PrivateExperience = lazy(() => import("./PrivateExperience"));
const RootExperience = () => {
  const location = useLocation();
  const publicRoute = isPublicTeachingPath(location.pathname);
  const initialPublic = useRef(publicRoute);
  // Never mount public content inside a document with active private replay/session providers.
  useEffect(() => {
    if (publicRoute !== initialPublic.current)
      window.location.replace(window.location.href);
  }, [publicRoute]);
  if (publicRoute !== initialPublic.current) return null;
  if (publicRoute) return <PublicTeachingApp />;
  return (
    <Suspense fallback={<Loader height="100vh" width="100vw" />}>
      <PrivateExperience />
    </Suspense>
  );
};
export default RootExperience;
